import { requester } from '../utils';
import cookies from 'js-cookie';

export const getPossibleReserveDates = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/get-possible-dates`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get possible date and times error", err);
        reject(err);
      });
  });
};

export const getPossibleReserveTables = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/get-possible-tables`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get possible tables error", err);
        reject(err);
      });
  });
};

export const createNewReserve = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        cookies.set('new-reserve', JSON.stringify(result.payload));
        let currentDate = new Date();
        let currentTime = currentDate.setSeconds(
          currentDate.getSeconds() + result.payload.timer,
        );
        cookies.set('reserve-timer', currentTime);
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('create new reserve error', err);
        reject(err);
      });
  });
};

export const cancelReserve = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/release-unpaid`,
        method: 'PUT',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('cancel unpaid reserve error', err);
        reject(err);
      });
  });
};

export const reservePayment = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/payment`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("reserve's payment error", err);
        reject(err);
      });
  });
};

export const getMyReserves = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/me`,
        method: 'POST',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('get my reserves error', err);
        reject(err);
      });
  });
};

export const cancelPaidReserve = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/cancel`,
        method: 'PUT',
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log('cancel paid reserve error', err);
        reject(err);
      });
  });
};

export const getMyReserveDetails = (id) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/app/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get my reserve's details error", err);
        reject(err);
      });
  });
};
